import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f1cda9b8")

_pushScopeId("data-v-f1cda9b8")
const _hoisted_1 = {
  class: "liste",
  id: "LOIwrapper"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createVNode("col", {
  span: "1",
  class: "number"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("col", {
  span: "1",
  class: "label"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("th", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("th", null, "Label / IRI", -1)
const _hoisted_7 = { id: "contentTbody" }
const _hoisted_8 = { class: "list-item" }
const _hoisted_9 = { class: "number" }
const _hoisted_10 = {
  key: 0,
  class: "same-predicate-list"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 1,
  class: "attribute-spinner"
}
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "additional-info" }
const _hoisted_15 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "navigation"
}
const _hoisted_17 = { class: "navigation-label" }
const _hoisted_18 = { class: "buttons" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "chevron_left", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "chevron_right", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("option", {
  id: "selectedoption",
  selected: ""
}, "25", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("option", null, "50", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("option", null, "75", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("option", null, "100", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("option", null, "125", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("option", null, "150", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.shownInstances.length)
        ? (_openBlock(), _createBlock("table", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedProperties, (p) => {
              return (_openBlock(), _createBlock("col", {
                span: "1",
                class: "property",
                key: p.iri
              }))
            }), 128)),
            _createVNode("thead", null, [
              _createVNode("tr", null, [
                _hoisted_5,
                _hoisted_6,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedProperties, (p) => {
                  return (_openBlock(), _createBlock("th", {
                    key: p.iri,
                    title: p.iri
                  }, _toDisplayString(p.label), 9, ["title"]))
                }), 128))
              ])
            ]),
            _createVNode("tbody", _hoisted_7, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.shownInstances, (element, index) => {
                return (_openBlock(), _createBlock(_Fragment, {
                  key: index +'-'+ element.iri
                }, [
                  _createVNode("tr", _hoisted_8, [
                    _createVNode("td", _hoisted_9, _toDisplayString(index + 1 + ((_ctx.currentPage - 1) * _ctx.maxCount)) + ". ", 1),
                    _createVNode("td", {
                      class: "label",
                      onClick: ($event: any) => (_ctx.onInstanceClick(element)),
                      title: element.iri
                    }, _toDisplayString(element.label), 9, ["onClick", "title"]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedProperties, (p) => {
                      return (_openBlock(), _createBlock("td", {
                        key: p.iri,
                        class: "property"
                      }, [
                        (element.getAttributesOfProperty(p.iri).size > 0)
                          ? (_openBlock(), _createBlock("ul", _hoisted_10, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(element.getAttributesOfProperty(p.iri), (a) => {
                                return (_openBlock(), _createBlock("li", { key: a }, [
                                  (_ctx.isObject(a))
                                    ? (_openBlock(), _createBlock("a", {
                                        key: 0,
                                        href: a.iri,
                                        target: "_blank",
                                        class: "material-icons object",
                                        title: a.iri
                                      }, "link", 8, ["href", "title"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.isObject(a) && a.hasProps)
                                    ? (_openBlock(), _createBlock("span", {
                                        key: 1,
                                        onClick: ($event: any) => (_ctx.onInstanceClick(a)),
                                        class: "object"
                                      }, _toDisplayString(a.label), 9, ["onClick"]))
                                    : (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(a.label || a), 1))
                                ]))
                              }), 128))
                            ]))
                          : (_ctx.fetchingAttributes)
                            ? (_openBlock(), _createBlock("div", _hoisted_12, [
                                _createVNode("span", null, [
                                  _createVNode(_component_LoadingSpinner)
                                ])
                              ]))
                            : (_openBlock(), _createBlock("span", _hoisted_13, " – "))
                      ]))
                    }), 128))
                  ]),
                  _createVNode("tr", _hoisted_14, [
                    _hoisted_15,
                    _createVNode("td", {
                      colspan: 2+(_ctx.selectedProperties.length),
                      class: "classInfoContent"
                    }, null, 8, ["colspan"])
                  ])
                ], 64))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.shownInstances.length)
      ? (_openBlock(), _createBlock("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _createVNode("span", null, [
              _createTextVNode(" Elemente " + _toDisplayString((_ctx.currentPage - 1) * _ctx.maxCount + 1) + "–" + _toDisplayString((_ctx.currentPage - 1) * _ctx.maxCount + _ctx.shownInstances.length) + " ", 1),
              (_ctx.classInfo.current.value.elementCount != null)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("von " + _toDisplayString(_ctx.classInfo.current.value.elementCount), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("button", {
              class: "button_left",
              disabled: (_ctx.currentPage === 1),
              onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.currentPage--;_ctx.pageInstances();_ctx.endOfList=false;})
            }, [
              _hoisted_19
            ], 8, ["disabled"]),
            _createVNode("button", {
              class: "button_right",
              disabled: _ctx.endOfList === true,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ForwardBtn()))
            }, [
              _hoisted_20
            ], 8, ["disabled"])
          ]),
          _createVNode("select", {
            id: "MaxCountDropDown",
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setMaxCount()))
          }, [
            _hoisted_21,
            _hoisted_22,
            _hoisted_23,
            _hoisted_24,
            _hoisted_25,
            _hoisted_26
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ], 64))
})